import * as R from "ramda";

import generator from "redux/hor/module";
import fetchWithView from "redux/utils/fetchWithView";

const { reducer, fetch } = generator({
  name: "normChildren",
  tableId: 129,
  parseItem: R.evolve({
    ___parent: R.propOr(null, "key"),
    custom_страна: R.propOr(null, "key"),
    custom_возрастные_группы: R.propOr(null, "label"),
    custom_группа_физической_активности: R.propOr(null, "label"),
  }),
});

export const fetchList = fetchWithView(fetch, "ts5c129cs9r424");

export { fetch };

export default reducer;
